import { defineStore } from 'pinia'
import repository from '@/repositories/repositoryFactory';

// 発注商品store
export const usePurchaseGoodsStore = defineStore({
    id: "mPurchaseGoods",
    state: () => {
        return {
            purchaseGoods: [] as MasterType.PurchaseGoods[],
            isLoaded : false
        }
    },
    actions: {
        // 発注商品取得
        async getPurchaseGoods(forceFlg: boolean = false) {
            // まだ取得していなかった場合、発注商品取得
            if (!this.isLoaded || forceFlg) {
                this.purchaseGoods = await repository.master.getPurchaseGoods();
                this.isLoaded = true;
            }
        }
    },
    // データの永続化(セッション単位)
    persist: {
        enabled: true,
        strategies: [
            {
                storage: sessionStorage
            }
        ]
    }
})

// 都道府県store
export const usePrefectureStore = defineStore({
    id: "mPrefecture",
    state: () => {
        return {
            prefectures: [] as MasterType.PrefectureInfo[],
            isLoaded: false
        }
    },
    actions: {
        // 都道府県情報取得
        async getPrefectureInfos(forceFlg: boolean = false) {
            // まだ取得していなかった場合、都道府県情報取得
            if (!this.isLoaded || forceFlg) {
                this.prefectures = await repository.master.getPrefectureInfos();
                this.isLoaded = true;
            }
        }
    },
    // データの永続化(セッション単位)
    persist: {
        enabled: true,
        strategies: [
            {
                storage: sessionStorage
            }
        ]
    }
})

// 直営ホールstore
export const useDirectHallsStore = defineStore({
    id: "mDirectHall",
    state: () => {
        return {
            directHalls: [] as MasterType.DirectHallsInfo[],
            isLoaded: false
        }
    },
    actions: {
        // 直営ホール情報取得
        async getDirectHalls(forceFlg: boolean = false) {
            // まだ取得していなかった場合、直営ホール情報取得
            if (!this.isLoaded || forceFlg) {
                this.directHalls = await repository.master.getDirectHalls();
                this.isLoaded = true;
            }
        }
    },
    // データの永続化(セッション単位)
    persist: {
        enabled: true,
        strategies: [
            {
                storage: sessionStorage
            }
        ]
    }
})